import { render, staticRenderFns } from "./cDetail.vue?vue&type=template&id=450fe1ee"
import script from "./cDetail.vue?vue&type=script&lang=js"
export * from "./cDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports